export const InvestorChartTypes = {
	RepaymentChart: 1,
	FundChart: 2,
};
